export default function BremaLogo({ className = "", height = 40 }) {
  return (
    <img
      src="/brand/LogoBrema_Negativo.svg"
      alt="Brema"
      style={{ height, width: "auto" }}
      className={className}
      draggable={false}
    />
  );
}
